<template>
    <div class="infoBox ServicePerson">
        <p class="title"><span>协助人</span> <span @click="$router.push('/staffSearch')">添加</span></p>
        <div class="ServiceBox">
            <div class="ServiceItemBox" v-for="(item,index) in list">
                <van-swipe-cell>
                    <div class="ServiceItem">
                        <img :src="item.header"/>
                        <span>{{item.b}}</span>
                        <input placeholder='(小时)' type='number' @input='inputValue($event,index)' :value='item.Time' />
                        <span>{{item.f}}</span>
                    </div>
                    <template #right>
                        <div class="delete" @click="_delete(index)">
                            <img src="../../assets/img/delete.png"/>
                        </div>
                    </template>
                </van-swipe-cell>
            </div>

        </div>
    </div>
</template>

<script>
    //  选择维修人 带添加删除功能
    import {SwipeCell} from 'vant'
    export default {
        name: 'ServicePerson',
        components: {
            [SwipeCell.name]: SwipeCell
        },
        props: {
            data: Array
        },
        data() {
            return {
                list: this.data||[],
            }
        },
        methods: {
            _delete(index) {
                this.list.splice(index,1)
                this.$emit('OnMessage',this.list)
            },inputValue(obj,index){
                this.list[index].Time=obj.target.value;
                this.$emit('OnMessage',this.list)
            }
        },
        mounted() {
            this.$Bus.$on('selectStaff', item => {
                let that=this;
                item.forEach(function(item,index){
                     that.list.push({a:item.UserCode||item.a,b:item.UserName||item.b,Time:!item.Time?null:item.Time,f:item.f,header: require('@/assets/img/person.png')});
                })
                this.$emit('OnMessage',this.list)
            })
        },
    }
</script>

<style scoped lang="scss">
    .ServicePerson{
        .title{
            display: flex;
            span:first-child{
                flex: 1;
            }
            span:last-child{
                font-size: 30px;
                color: $THEME-COLOR;
            }
        }
    }
    .ServiceBox{
        .ServiceItem{
            height: 110px;
            display: flex;
            align-items: center;
            color: #333;
            font-size: 28px;
            img{
                width: 60px;
                height: 60px;
                border-radius: 50%;
                margin-right: 40px;
            }
            &>span{
              width: 26vw;
              &:last-child{
                  margin-left: 8vw;
              }
            }
            input{
                width: 13%;
            }
        }
        .ServiceItemBox{
            border-bottom: 2px solid #F3F3F3;
            &:last-child{
                border: none
            }
        }
    }
    .delete{
        width: 64px;
        height: 64px;
        background: #F25643;
        border-radius: 50%;
        text-align: center;
        margin-top: 24px;
        img{
            width: 40px;
            margin-top: 12px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/servicePerson/servicePerson.vue